export const SOURCE_NAME_EMPTY_ERROR = 'Source Name cannot be empty';
export const SOURCE_NAME_MAX_LENGTH = 75;
export const SOURCE_NAME_MAX_LENGTH_ERROR = 'Source Name exceeds 75 characters!';
export const SOURCE_NAME_INVALID_CHAR_ERROR = 'Source Name has invalid characters';
export const COMPANY_FOOTPRINT_TITLE = 'EY Company Footprint';
export const COMPANY_FOOTPRINT_GUIDE = `Below listed are the EY Company Footprints. Here you can make changes to the EY Company footprint, to propagate your changes to external Application, click on <mark>'Map to GBB Public'</mark>.`;
export const DESCRIPTION_EMPTY_ERROR = 'Description cannot be empty';
export const DESCRIPTION_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH_ERROR = 'Description text exceeds 100 characters!';
export const YEAR_EMPTY_ERROR = 'This field is required';
export const YEAR_SHORT_DATE_FORMAT_ERROR =
    'Invalid date format. format should be "YY-MMM", Select the date.';
export const EDIT_EY_FOOTPRINT_INFO = 'Edit - Company Info';
export const GET_EY_FOOTPRINT_INFO_FAILED = 'Failed to get EY Footprint Information';
export const UPDATE_EY_FOOTPRINT_INFO_FAILED = 'Failed to update EY Footprint Information';
export const UPDATE_EY_FOOTPRINT_INFO_SUCCESS = 'Successfully updated EY Footprint Information';
import { Action } from 'common/enums';
import { GridApi } from 'ag-grid-community/dist/lib/gridApi';
export const getCompanyFootprintColDefs = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleAction: (action: Action, data: any, api: GridApi) => void,
    isActionDisabled = false,
    minWidth = 100
) => [
    {
        field: 'locationName',
        headerName: 'Country',
        minWidth: minWidth,
        width: 200,
        resizable: true,
        cellRenderer: 'LabelCellRenderer',
        cellRendererParams: {
            className: 'ellipsis'
        }
    },
    {
        field: 'isEYPresence',
        headerName: 'EY Presence',
        width: 350,
        resizable: true,
        cellRenderer: 'ToggleSwitchCellRenderer',
        cellRendererParams: {
            onAction: handleAction,
            isActionDisabled: isActionDisabled
        }
    }
];
